export default __webpack_public_path__ + "static/media/stagger5.37e1177c.png";